import { render, staticRenderFns } from "./RoleResources.vue?vue&type=template&id=05610094&scoped=true&"
import script from "./RoleResources.vue?vue&type=script&lang=ts&"
export * from "./RoleResources.vue?vue&type=script&lang=ts&"
import style0 from "./RoleResources.vue?vue&type=style&index=0&id=05610094&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05610094",
  null
  
)

export default component.exports